/*
 *
 * GenericModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 09-Sep-2024
*/

import { connect } from 'react-redux'
import GenericModal from './GenericModal'
import { nullSafe } from 'Utility/globalMethods'

const mapStateToProps = state => ({
  title: nullSafe(() => state.popup.popupInfo.title, ''),
  topBarTitle: nullSafe(() => state.popup.popupInfo.topBarTitle, ''),
  description: nullSafe(() => state.popup.popupInfo.description, ''),
  customAnalyticsDescription: nullSafe(() => state.popup.popupInfo.customAnalyticsDescription, ''),
  children: nullSafe(() => state.popup.popupInfo.children, null),
  onClose: nullSafe(() => state.popup.popupInfo.onClose, () => { }),
  primaryButtonLabel: nullSafe(() => state.popup.popupInfo.primaryButtonLabel, ''),
  primaryButtonIcon: nullSafe(() => state.popup.popupInfo.primaryButtonIcon, ''),
  secondaryButtonLabel: nullSafe(() => state.popup.popupInfo.secondaryButtonLabel, ''),
  secondaryAction: nullSafe(() => state.popup.popupInfo.secondaryAction, () => { }),
  secondaryIcon: nullSafe(() => state.popup.popupInfo.secondaryIcon, ''),
  primaryIcon: nullSafe(() => state.popup.popupInfo.primaryIcon, ''),
  primaryAction: nullSafe(() => state.popup.popupInfo.primaryAction, () => { }),
  primaryButtonLoading: nullSafe(() => state.loading.localLoading[state.popup.popupInfo.primaryActionRequest], false),
  secondaryButtonLoading: nullSafe(() => state.loading.localLoading[state.popup.popupInfo.secondaryActionRequest], false)
})

export default connect(mapStateToProps, null, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(GenericModal)
